import {useLoginContext, useUserContext} from '@hconnect/login'
import {LoadingSwitcher, Content} from '@hconnect/uikit/src/lib2'
import React from 'react'
import {Outlet} from 'react-router'

import {LoginPage} from './LoginPage'

export const LoginGuard: React.FC = () => {
  const {isLoggedIn} = useLoginContext()
  const {loggedUser} = useUserContext()

  if (!isLoggedIn) {
    return <LoginPage />
  }

  return (
    <LoadingSwitcher variant="overlay" isLoading={!loggedUser}>
      {loggedUser ? <Outlet /> : <Content sx={{width: '100vw', height: '100vh'}} />}
    </LoadingSwitcher>
  )
}
